import { render, staticRenderFns } from "./miaosha.vue?vue&type=template&id=0e12f1b6&"
import script from "./miaosha.vue?vue&type=script&lang=js&"
export * from "./miaosha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports